/**
 * Every route becomes a chunk, loaded only when used.
 * Reduces size of initial App load.
 */
// import Splash from "@/views/Splash.vue";
// const Login = () => import(/* webpackChunkName: "login" */ "@/views/Login.vue");
// const Registration = () =>
//   import(/* webpackChunkName: "signup" */ "@/views/Registration.vue");

const Home = () =>
  import(/* webpackChunkName: "home" */ "@/views/Home");
  const Profile = () =>
  import(/* webpackChunkName: "profile" */ "@/views/Profile");
  const LeaderBoard = () =>
  import(/* webpackChunkName: "leaderBoard" */ "@/views/LeaderBoard");
  const SubmitTask = () =>
  import(/* webpackChunkName: "submitTask" */ "@/views/SubmitTask");
  const TaskDetail = () =>
  import(/* webpackChunkName: "taskDetail" */ "@/views/TaskDetail");
  const Registration = () =>
  import(/* webpackChunkName: "registration" */ "@/views/Registration");
  const PaymentConfirmation = () =>
  import(/* webpackChunkName: "paymentConfirmation" */ "@/views/PaymentConfirmation");
  const DashBoard = () =>
  import(/* webpackChunkName: "dashBoard" */ "@/views/DashBoard");
  const AudioRecording = () =>
  import(/* webpackChunkName: "audioRecording" */ "@/components/NewsModule/AudioRecording");
  const AudioPreview = () =>
  import(/* webpackChunkName: "audioPreview" */ "@/components/NewsModule/AudioPreview");
  const VideoRecording = () =>
  import(/* webpackChunkName: "videoRecording" */ "@/components/NewsModule/VideoRecording");
  const VideoPreview = () =>
  import(/* webpackChunkName: "videoPreview" */ "@/components/NewsModule/VideoPreview");
  const UploadSuccess = () =>
  import (/*webpackChunkName: "uploadSuccess" */ "@/components/UploadSuccess")
  const AllTaskDetail = () =>
  import (/*webpackChunkName: "allTaskDetail" */ "@/components/AllTaskDetail")
  const MyTaskDetail = () =>
  import (/*webpackChunkName: "myTaskDetail" */ "@/components/MyTaskDetail")
  const UploadedNews = () => 
  import (/*webpackChunkName: "uploadedNews" */ "@/components/NewsModule/UploadedNews")

   const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/leader-board',
      name: 'LeaderBoard',
      component: LeaderBoard
    },
    {
      path: '/submit-task',
      name: 'SubmitTask',
      component: SubmitTask
    },
    {
      path: '/task-detail',
      name: 'TaskDetail',
      component: TaskDetail
    },
    {
      path: '/all-task-detail',
      name: 'AllTaskDetail',
      component: AllTaskDetail
    },
    {
      path: '/my-task-detail',
      name: 'MyTaskDetail',
      component: MyTaskDetail
    },
    {
      path: '/upload-success',
      name: 'UploadSuccess',
      component: UploadSuccess
    },
    {
      path: '/sign-up',
      name: 'Registration',
      component: Registration
    },
    {
      path: '/payment-confirmation',
      name: 'PaymentConfirmation',
      component: PaymentConfirmation
    },
    {
      path: '/dashboard',
      name: 'DashBoard',
      component: DashBoard
    },
    {
      path: '/audio-record',
      name: 'AudioRecording',
      component: AudioRecording
    },
    {
      path: '/video-record',
      name: 'VideoRecording',
      component: VideoRecording
    },
    {
      path: '/video-preview',
      name: 'VideoPreview',
      component: VideoPreview
    },
    {
      path: '/audio-preview',
      name: 'AudioPreview',
      component: AudioPreview
    },
    {
      path: '/uploaded-news',
      name: 'UploadedNews',
      component: UploadedNews
    }
  ]

export default routes;
